<template>
      <a href="#" :loading="isLoading" v-on:click.prevent.stop="performSynchronization">
        <span :class="['glyphicon', 'glyphicon-refresh', {'spin': isLoading}]"></span>
        {{$t('marker.ftp.synchronize')}}
      </a>  
</template>

<script>
import MarkerRepository from '../../repositories/MarkerRepository'

export default {
  props: {
    markerId: {
      type: Number,
      required: false
    }
  },
  data () {
    return {
      isLoading: false
    }
  },
  methods: {
    async performSynchronization () {
      this.isLoading = true
      try {
        const response = await MarkerRepository.triggerFTPSync(this.markerId)
        this.notifySuccess(response)
      } catch (error) {
        this.notifyError(error)
      } finally {
        this.isLoading = false
      }
    },
    notifySuccess (response) {
      const dataLink = response.path_to_marker_data
      const message = this.$t('marker.ftp.records_link')
      this.$store.commit('snackbar/show', { href: dataLink, message })
    },
    async notifyError (error) {
      const { response } = error
      let json
      try {
        json = await response.json()
      } catch (e) {
        json = {}
      }
      const { non_field_errors: nonFieldErrors, detail } = json
      const message = nonFieldErrors || detail || this.$t('marker.ftp.sync_error')
      this.$store.commit('snackbar/show', { message, color: 'error' })
    }
  }
}
</script>

<style lang="scss">
@import "../../assets/css/animations.scss";
</style>



// WEBPACK FOOTER //
// FTPSyncButton.vue?7c4956ba